import type { ReactNode } from 'react'
import { BarChart3, KeyRound, TableProperties } from 'lucide-react'
import { Link, NavLink } from 'react-router'

const views = [
  { path: '/collection-keywords/analysis', label: 'Collection-Analyse', icon: KeyRound },
  { path: '/collection-keywords/coverage', label: 'Collection-Abdeckung', icon: TableProperties },
  { path: '/collection-keywords/traffic', label: 'Collection-Traffic', icon: BarChart3 },
] as const

export function CollectionKeywordNav(): ReactNode {
  return (
    <div className="mb-6 rounded-2xl border border-slate-200 bg-white p-3 shadow-sm dark:border-slate-700 dark:bg-slate-900">
      <p className="mb-2 px-2 text-xs font-black uppercase tracking-[0.14em] text-slate-500 dark:text-slate-400">
        Collection-Keywords
      </p>
      <nav aria-label="Collection-Keywords" className="flex flex-wrap gap-2">
        {views.map((view) => {
          const Icon = view.icon
          return (
            <NavLink
              key={view.path}
              to={view.path}
              className={({ isActive }) =>
                isActive
                  ? 'inline-flex items-center gap-2 rounded-xl bg-fuchsia-600 px-4 py-2.5 text-sm font-bold text-white shadow-sm'
                  : 'inline-flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800'
              }
            >
              <Icon aria-hidden="true" size={16} />
              {view.label}
            </NavLink>
          )
        })}
      </nav>
      <div className="mt-3 flex flex-wrap gap-2 border-t border-slate-200 pt-3 dark:border-slate-700">
        <Link
          to="/producttype-keywords/analysis"
          className="rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-semibold text-slate-600 hover:bg-slate-100 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800"
        >
          Produkttyp-Keywords
        </Link>
        <button
          type="button"
          disabled
          className="cursor-not-allowed rounded-xl border border-dashed border-slate-300 bg-slate-100 px-4 py-2.5 text-sm font-semibold text-slate-400 dark:border-slate-700 dark:bg-slate-800/60"
        >
          Motiv-Keywords · Kommt noch
        </button>
      </div>
    </div>
  )
}
